module.exports = __webpack_public_path__ + "img/shoppingbag02.240cfa6a.jpg";